import React from 'react';
import { HandSummaryFull, HandSummaryStreetAction } from '../../pages/HandReplayerPage';
import { Street } from '../../pages/PlaygroundPage/PlaygroundPage';
import './ReplayerActionTimeline.css';

interface ReplayerActionTimelineProps {
  handData: HandSummaryFull | null;
  currentStreetKey: Street;
  currentActionIndex: number;
  allPlayersInHand: Array<{ id: number; name: string }>;
}

const streetsOrder: Street[] = ['preflop', 'flop', 'turn', 'river'];

interface EnrichedAction extends HandSummaryStreetAction {
  street: Street;
  actionGlobalIndex: number;
  playerName: string;
}

const ReplayerActionTimeline: React.FC<ReplayerActionTimelineProps> = ({
  handData,
  currentStreetKey,
  currentActionIndex,
  allPlayersInHand,
}) => {
  if (!handData) {
    return <div className="no-data-message">No hand data loaded for timeline.</div>;
  }

  const allActions: EnrichedAction[] = [];
  let globalActionCounter = 0;

  streetsOrder.forEach(street => {
    const streetKey = street as keyof Pick<HandSummaryFull, 'preflop' | 'flop' | 'turn' | 'river'>;
    const streetData = handData[streetKey];
    if (streetData && streetData.actions) {
      streetData.actions.forEach(action => {
        const player = allPlayersInHand.find(p => p.id === action.playerId);
        allActions.push({
          ...action,
          street: street,
          actionGlobalIndex: globalActionCounter++,
          playerName: player ? player.name : `Player ${action.playerId}`,
        });
      });
    }
  });

  let currentGlobalActionIndex = -1;
  if (currentActionIndex > -1) {
    let count = 0;
    for (const street of streetsOrder) {
      const streetKey = street as keyof Pick<HandSummaryFull, 'preflop' | 'flop' | 'turn' | 'river'>;
      const streetData = handData[streetKey];
      if (street === currentStreetKey) {
        currentGlobalActionIndex = count + currentActionIndex;
        break;
      }
      if (streetData && streetData.actions) {
        count += streetData.actions.length;
      }
    }
  }

  if (allActions.length === 0) {
    return <div className="no-data-message">No actions in this hand.</div>;
  }

  return (
    <div className="replayer-action-timeline">
      <h4 className="timeline-header">Action Timeline</h4>
      <ul className="replayer-action-list">
        {allActions.map((action) => {
          const isCurrentAction = action.actionGlobalIndex === currentGlobalActionIndex;
          return (
            <li
              key={`${action.street}-${action.actionGlobalIndex}-${action.playerId}`}
              className={`replayer-action-item ${isCurrentAction ? 'current-action' : ''}`}
            >
              <span className="action-details">
                <strong className="street-name">{action.street.charAt(0).toUpperCase() + action.street.slice(1)}:</strong> {action.playerName}
              </span>
              <span className="action-info">
                {action.type.toUpperCase()}
                {action.amount !== null && action.amount > 0 ? ` $${action.amount}` : ''}
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default ReplayerActionTimeline; 